import * as runtime from '../runtime'

export class RemindHistoriesApi extends runtime.BaseAPI {
  /**
   *  利用者IDにより督促情報を更新する
   *  利用者督促情報更新
   */
  async deleteRemindHistoriesById(
    id: number
  ): Promise<runtime.VoidApiResponse> {
    const response = await this.requestDelete(`/remind-histories/${id}`)

    return new runtime.VoidApiResponse(response)
  }

  /**
   *  利用者IDにより督促情報を更新する
   *  利用者督促情報更新
   */
  async delete(id: number): Promise<runtime.VoidApiResponse> {
    const response = await this.requestDelete(`/remind-histories/${id}`)

    return new runtime.VoidApiResponse(response)
  }
}
